import React, { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import SuccessPopupAlert from "../components/PopupAlertSuccess/PopupAlert";
import { Outlet } from "react-router-dom";

export const PermissionProvider = ({ children }) => {
  const [permissionUpdatePopup, setPermissionUpdatePopup] = useState(false);

  const adminDataId = localStorage.getItem("adminId");
  const roleDataId = localStorage.getItem("roleId");
  useEffect(() => {
    const socket = io("https://salesservices.codelynks.in", {
      auth: {
        userId: adminDataId,
        roleId: roleDataId
      },
      transports: ["websocket"],
    });

    socket.on("connect", () => {
      console.log("Socket.IO connection established.");
    });

    socket.on("permissions", (data) => {
      console.log("data__", data)
      localStorage.setItem(
        "permissions",
        JSON.stringify(data?.permissions?.permissions)
      );
      localStorage.setItem(
        "roleIdentifier",
        JSON.stringify(data?.permissions?.identifier)
      );
      localStorage.setItem(
        "roleId",
        (data?.permissions?._id)
      );
      setPermissionUpdatePopup(true);
    });

    socket.on("disconnect", () => {
      console.log("Socket.IO connection disconnected.");
    });

    socket.on("error", (error) => {
      console.error("Socket.IO error:", error);
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  const handleSuccessPopup = () => {
    setPermissionUpdatePopup(false);
    window.location.reload();
  };

  return (
    <div>
      <Outlet />
      <SuccessPopupAlert
        show={permissionUpdatePopup}
        alertMessage={"Your permission has been updated"}
        handleSubmit={() => handleSuccessPopup()}
      />
      ;
    </div>
  );
};

export default PermissionProvider;
